var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { userState } from "@/views/Auth/state";
import { useAPI } from "./useAPI";
import { accessTokenState, tokenExpirationState, refreshTokenState, haveCheckedAuthState } from "../views/Auth/state";
import { merchantState, merchantsState, rolesState } from "@/views/Home/state";
export var useAuth = function () {
    var hitAPI = useAPI();
    var navigate = useNavigate();
    var _a = useRecoilState(userState), user = _a[0], setUser = _a[1];
    var setAccessToken = useSetRecoilState(accessTokenState);
    var setRefreshToken = useSetRecoilState(refreshTokenState);
    var setTokenExpiration = useSetRecoilState(tokenExpirationState);
    var setChecked = useSetRecoilState(haveCheckedAuthState);
    var setMerchant = useSetRecoilState(merchantState);
    var setMerchants = useSetRecoilState(merchantsState);
    var setRoles = useSetRecoilState(rolesState);
    var login = function (email, password) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, hitAPI("/auth/login", "POST", {
                        email: email,
                        password: password,
                    })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (response.status !== 200) {
                        throw new Error(data.message);
                    }
                    setUser(data.data.user);
                    setAccessToken(data.data.access_token);
                    // Clear merchant state to prevent using cached merchant from previous session
                    setMerchant(null);
                    setMerchants([]);
                    setRoles([]);
                    // Reset checked state to force ProtectedRoute to re-check auth
                    setChecked(false);
                    navigate("/");
                    return [2 /*return*/];
            }
        });
    }); };
    var loginWithCognito = function () { return __awaiter(void 0, void 0, void 0, function () {
        var redirectUri, response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    redirectUri = "".concat(window.location.origin, "/auth/cognito/callback");
                    return [4 /*yield*/, hitAPI("/auth/cognito/login/url?redirect_uri=".concat(encodeURIComponent(redirectUri)), "GET")];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (response.status !== 200) {
                        throw new Error(data.message || "Failed to get Cognito login URL");
                    }
                    // Redirect to Cognito login page
                    window.location.href = data.data.login_url;
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCognitoCallback = function (code) { return __awaiter(void 0, void 0, void 0, function () {
        var redirectUri, response, data, expirationTime;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    redirectUri = "".concat(window.location.origin, "/auth/cognito/callback");
                    return [4 /*yield*/, hitAPI("/auth/cognito/login/callback", "POST", {
                            code: code,
                            redirect_uri: redirectUri,
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    if (response.status !== 200) {
                        throw new Error(data.message || "Failed to handle Cognito callback");
                    }
                    // Store Cognito tokens
                    setUser(data.data.user);
                    // Store the access token and refresh token from Cognito
                    if ((_a = data.data.cognito_tokens) === null || _a === void 0 ? void 0 : _a.access_token) {
                        setAccessToken(data.data.cognito_tokens.access_token);
                        // Store refresh token for auto-refresh
                        if (data.data.cognito_tokens.refresh_token) {
                            setRefreshToken(data.data.cognito_tokens.refresh_token);
                        }
                        // Store token expiration time (current time + expires_in seconds)
                        if (data.data.cognito_tokens.expires_in) {
                            expirationTime = Date.now() + (data.data.cognito_tokens.expires_in * 1000);
                            setTokenExpiration(expirationTime);
                        }
                    }
                    // Clear merchant state to prevent using cached merchant from previous session
                    setMerchant(null);
                    setMerchants([]);
                    setRoles([]);
                    // Reset checked state to force ProtectedRoute to re-check auth
                    setChecked(false);
                    navigate("/");
                    return [2 /*return*/];
            }
        });
    }); };
    var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, hitAPI("/auth/logout", "DELETE")];
                case 1:
                    _a.sent();
                    // Clear all auth state
                    setUser(null);
                    setAccessToken("");
                    setRefreshToken("");
                    setTokenExpiration(null);
                    setChecked(false);
                    // Clear all merchant state
                    setMerchant(null);
                    setMerchants([]);
                    setRoles([]);
                    navigate("/auth/login", { replace: true });
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        user: user,
        login: login,
        loginWithCognito: loginWithCognito,
        handleCognitoCallback: handleCognitoCallback,
        logout: logout,
    };
};
